import { Button } from '@petsmart-ui/sparky';
import { useEffect } from 'react';
import { usePageLayout } from '@libs/common-next';
import type { AddToCartProps } from './types';

export default function AddToCartBtn({
    disabled,
    text,
    className,
    addedToCart,
    setAddedToCart,
    isLoading,
}: AddToCartProps) {
    const { errorAlert } = usePageLayout();
    useEffect(() => {
        let timerId: NodeJS.Timeout | undefined;

        if (addedToCart && setAddedToCart) {
            timerId = setTimeout(() => {
                setAddedToCart(false);
            }, 3000);
        }

        return () => {
            if (timerId && setAddedToCart) {
                clearTimeout(timerId);
                setAddedToCart(false);
            }
        };
    }, [addedToCart, setAddedToCart]);

    return (
        <Button
            type="submit"
            variant="primary"
            disabled={disabled}
            data-testid="add-to-cart-button"
            loading={isLoading && !errorAlert}
            className={className || 'add-to-cart-button'}
            text={isLoading && !errorAlert ? null : text || 'Add to cart'}
        />
    );
}
